import { useMemo } from 'react';

import type { GridInitialState } from '@mui/x-data-grid';

import { useReferencesContext } from '../../../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { THIRD_PARTY_STATUS_ID } from '../../../../../components/ThirdParties/columns/get-third-party-columns';

export const useInitialGridState = () => {
  const { genericStatusesCodeMap } = useReferencesContext();

  const initialGridState = useMemo<GridInitialState>(
    () => ({
      columns: {
        columnVisibilityModel: {
          [THIRD_PARTY_STATUS_ID]: false,
        },
      },
      filter: {
        filterModel: {
          items: [
            {
              field: THIRD_PARTY_STATUS_ID,
              operator: 'is',
              value: genericStatusesCodeMap.Enabled.code,
            },
          ],
        },
      },
    }),
    [genericStatusesCodeMap.Enabled.code],
  );

  return { initialGridState };
};
